export default __webpack_public_path__ + "static/media/33.f1c9531c.png";